import { ContactsForm } from './_form'

export function initContactsForm() {
  const container = document.querySelector<HTMLElement>(
    '[data-contacts="form"]'
  )
  if (container) {
    new ContactsForm(container)
  }
}
